import ChatMessage from "./ChatMessage";

class AttachmentMessage extends ChatMessage {

    constructor({ id, textMessage, room, hidden, unsent, attachment, loading, timestamp, msgType, author, authorSid, isOther, authorIdentity, index, attributes, roomId, roomLastConsumedMessageIndex}) {
        super({ id, textMessage, room, hidden, unsent, timestamp, msgType, author, authorSid, isOther, authorIdentity, index, attributes, roomId, roomLastConsumedMessageIndex })
        this.attachment = attachment;
        this.loading=loading;
    }

    setIsOther(isOther){
        super.setIsOther(isOther)
    }
}

export default AttachmentMessage;



// WEBPACK FOOTER //
// ./src/platform/chat/model/AttachmentMessage.js